import React, { useState } from 'react';
import { HomeIcon, InfoIcon, BriefcaseIcon, RssIcon, MailIcon } from './icons/Icons';
import { ReactComponent as KslLogo } from '../../assets/images/KslWhiteLogo.svg';

const navItems = [
  { id: 'home', label: 'Home', icon: <HomeIcon /> },
  { id: 'about', label: 'About Us', icon: <InfoIcon /> },
  { id: 'services', label: 'Services', icon: <BriefcaseIcon /> },
  { id: 'blog', label: 'Blog', icon: <RssIcon /> },
  { id: 'contact', label: 'Contact', icon: <MailIcon /> },
];

function Navbar({ currentPage, navigateTo }) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <nav className="hero-bg shadow-lg sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <div className="flex items-center">
            <div className="flex-shrink-0 cursor-pointer" onClick={() => navigateTo('home')}>
              <KslLogo className="h-10 w-auto" aria-label="KSL Logo" />
            </div>
          </div>
          <div className="hidden md:block">
            <div className="ml-10 flex items-baseline space-x-4">
              {navItems.map(item => (
                <a
                  key={item.id}
                  href="#"
                  onClick={e => { e.preventDefault(); navigateTo(item.id); }}
                  className={`nav-link ${currentPage === item.id ? 'nav-link-active' : ''} flex items-center space-x-2`}
                  aria-current={currentPage === item.id ? 'page' : undefined}
                >
                  {item.icon}
                  <span>{item.label}</span>
                </a>
              ))}
            </div>
          </div>
          <div className="md:hidden flex items-center">
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              type="button"
              className="bg-gray-800 inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-white hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white"
              aria-controls="mobile-menu"
              aria-expanded={isMobileMenuOpen}
            >
              <span className="sr-only">Open main menu</span>
              {!isMobileMenuOpen ? (
                <svg className="block h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
                </svg>
              ) : (
                <svg className="block h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              )}
            </button>
          </div>
        </div>
      </div>
      {isMobileMenuOpen && (
        <div className="md:hidden" id="mobile-menu">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
            {navItems.map(item => (
              <a
                key={item.id}
                href="#"
                onClick={e => { e.preventDefault(); navigateTo(item.id); setIsMobileMenuOpen(false); }}
                className={`nav-link ${currentPage === item.id ? 'nav-link-active' : ''} block flex items-center space-x-2`}
                aria-current={currentPage === item.id ? 'page' : undefined}
              >
                {item.icon}
                <span>{item.label}</span>
              </a>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
}

export default Navbar; 